import React from "react"
import autobind from "class-autobind"
import TimelineTable from "../../../../components/schedule/daily_timeline/TimelineTable"
import { ISchedulePatternTemplate, IScheduleDailyTimelineData, IScheduleShift, IJobDocument, IClientDocument, IScheduleDelay, IDate } from "../../../../models"
import strings from "../../../../localization/strings"
import AccountStore from "../../../../stores/AccountStore"
import AppStateStore from "../../../../stores/AppStateStore"
import * as utils from "../../../../helpers/utils"
import * as timeHelper from "../../../../helpers/timeHelper"
import { Table, TableBody, TableRow, TableRowColumn, Chip, Avatar, Badge } from "material-ui"
import ToolTip from "react-portal-tooltip"
import ImageLoader from "../../../../components/misc/ImageLoader"
import * as permissionHelper from "../../../../helpers/permissionHelper"
import AuthenticationStore from "../../../../stores/AuthenticationStore"
import AddIcon from "material-ui/svg-icons/content/add-circle"
import ImageTimer from "material-ui/svg-icons/image/timer"
import moment from "moment"
import TableActionBar from "../../../layout/TableActionBar"
import ConfirmDialog from "../../../common/ConfirmDialog"
import * as scheduleHelper from "../../../../helpers/scheduleHelper"
import * as colorHelper from "../../../../helpers/colorHelper"

interface IProps {
	delaysForDay: IScheduleDelay[]
	patternTemplates: ISchedulePatternTemplate[]
	readonly?: boolean
	allowDragDrop?: boolean
	handleAssignEmployee(assignPatternTemplate: ISchedulePatternTemplate): void
	handleUpdateTimelineData(timelineItem: IScheduleDailyTimelineData, shiftTemplate: IScheduleShift): void
	checkValidateNewTimeline(timelineItem: IScheduleDailyTimelineData, updateShiftTemplate: IScheduleShift, patternTemplate: ISchedulePatternTemplate): boolean
	handleDeleteTimelineItem(deleteShiftTemplate: IScheduleShift): void
	handleDeletePatternTemplates(patternTemplates: ISchedulePatternTemplate[]): void
	handleUpdateTimelineItem(item: IScheduleShift): void
	handleAddShiftTemplate(patternTemplate: ISchedulePatternTemplate): void
	handleShowTimecardPopup(employeeId: string, referenceDate: IDate): void
	handleUnAssignEmployee(patternTemplate: ISchedulePatternTemplate): void
	handleDragPatternTemplate(dragDropPatternTemplateId: string, moveUp: number, reorderItems: ISchedulePatternTemplate[]): void
	handleDropPatternTemplate(): void
	handleOpenCloneDialog(candidateClonePatternTemplates: ISchedulePatternTemplate[]): void

	// allow to edit by Tab
	allowQuickEditTime?: boolean
	excludeNonProductive?: boolean
	scheduleJob: IJobDocument
	scheduleClient: IClientDocument
}
interface IState {
	width: number
	searchText: string
	selectedPatternTemplates: ISchedulePatternTemplate[]
	confirmDialogContent: string
	confirmDialogPayload: any
	toolTip: string
	userTypeToolTip: string
}

export default class ScheduleTimeInfoDetailDayView extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props)
		this.state = {
			width: 1200,
			searchText: "",
			selectedPatternTemplates: [],
			confirmDialogContent: "",
			confirmDialogPayload: null,
			toolTip: undefined,
			userTypeToolTip: undefined,
		}
		autobind(this)
	}


	componentDidMount() {
		this.updateDimensions()
		window.addEventListener("resize", this.updateDimensions)
		AppStateStore.on("change", this.updateDimensions)
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.updateDimensions)
		AppStateStore.removeListener("change", this.updateDimensions)
	}

	updateDimensions() {
		const scheduleTimeInfoDetailDom = document.getElementById("ScheduleViewPlace")
		const width = scheduleTimeInfoDetailDom.offsetWidth - Number(scheduleTimeInfoDetailDom.style.paddingLeft.replace("px", "")) - Number(scheduleTimeInfoDetailDom.style.paddingRight.replace("px", ""))
		this.setState({ width })
	}

	getIimelineItemRenderElement(timelineItem: IScheduleDailyTimelineData, rowNumber: number, orderNumber: number) {
		const patternTemplates = this.props.patternTemplates.filter(pt => this.state.searchText ? pt.Name.toLocaleLowerCase().includes(this.state.searchText.toLocaleLowerCase()) : true)
		const timelineItemData = patternTemplates[rowNumber].ShiftTemplates[orderNumber]
		return (
			<TimelineItem
				timelineItem={timelineItem}
				rowNumber={rowNumber}
				orderNumber={orderNumber}
				patternTemplates={patternTemplates}
				timelineItemData={timelineItemData}
				handleShowTimecardPopup={this.props.handleShowTimecardPopup}
			/>
		)
	}

	showTooltip(id) {
		this.setState({
			toolTip: id
		})
	}

	showUserTypeTooltip(id) {
		this.setState({
			userTypeToolTip: id
		})
	}

	render() {
		const patternTemplates = this.props.patternTemplates.filter(pt => this.state.searchText ? pt.Name.toLocaleLowerCase().includes(this.state.searchText.toLocaleLowerCase()) : true)
		const timelineData: IScheduleDailyTimelineData[][] = new Array(patternTemplates.length)
		patternTemplates.forEach((pt, ptIndex) => {
			const dailyTimelineData: IScheduleDailyTimelineData[] = []
			pt.ShiftTemplates.forEach((shiftTemplate, stIndex) => {
				let position = AccountStore.getCurrentAccount().PositionDefinitions.find((item) => item.Id === shiftTemplate.PositionId)
				// use the position color of the shift template if it exists, otherwise use the position color of the account position
				if (shiftTemplate.Position) {
					position = shiftTemplate.Position
				}
				const backgroundColor = position && position.Color ? position.Color : AccountStore.getPositionDefaultColor()
				dailyTimelineData.push(scheduleHelper.getTimelineTableDataFromShift(shiftTemplate, backgroundColor))
			})
			timelineData[ptIndex] = dailyTimelineData
		})


		const leftSideColumns = [{
			HeaderLabel: strings.Name,
			HeaderStyle: { textAlign: "left", paddingLeft: 0, paddingRight: 0 } as React.CSSProperties,
			Col: (row: ISchedulePatternTemplate) => {
				var rowId = row && row.ShiftTemplates && row.ShiftTemplates.length > 0 ? row.ShiftTemplates[0].Id : null
				let overtimeNote = ""
				let overtimeColor = "#4CAF50"		// default color is green

				// sonar-ignore-next-line
				if (row && row.ShiftTemplates && row.ShiftTemplates.length > 0 && row.ShiftTemplates[0].Description != null) {
					overtimeNote = row.ShiftTemplates[0].Description
					if (overtimeNote.toLowerCase().includes("overtime")) {
						overtimeColor = "#f44336"		// red color for overtime
					}
                }

				var formatter = new Intl.NumberFormat('en-US', {
					style: 'currency',
					currency: 'USD',
				});

				let redMarginColor = undefined
				// sonar-ignore-start
				if (row && row.BudgetSummary && row.BudgetSummary.Margin < 20) {
					redMarginColor = "#f44336";
				}
				// sonar-ignore-end

				const userType = (row && AccountStore.getCRMEnabled() && (row.FloatUser || row.PerDiemUser || row.AgencyUser)) ?
					<span style={{ fontSize: 15 }}
						onMouseEnter={() => this.showUserTypeTooltip(rowId)}
						onMouseLeave={() => this.showUserTypeTooltip(undefined)}
						id={"schedule-row-employee-type-" + rowId}
					>
						<i
							className={colorHelper.getEmployeeTypeStyleData(row.FloatUser, row.PerDiemUser, row.AgencyUser).className}
							style={{ color: colorHelper.getEmployeeTypeStyleData(row.FloatUser, row.PerDiemUser, row.AgencyUser).color }}
						/>
						<ToolTip
							active={rowId === this.state.userTypeToolTip}
							position="top"
							arrow="left"
							parent={"#schedule-row-employee-type-" + rowId}
							key={"#schedule-row-employee-type-" + rowId}
							group={"#schedule-row-employee-type-" + rowId}
						>
							{!row.FloatUser && !row.PerDiemUser && !row.AgencyUser && <span>Core Staff</span>}
							{row.FloatUser && <span>Float Staff</span>}
							{row.PerDiemUser && <span>Per Diem Staff</span>}
							{row.AgencyUser && <span>Agency Staff</span>}
						</ToolTip>
					</span> : undefined

				const budget = (row && row.BudgetSummary && AccountStore.getCRMEnabled()) ?
					<span style={{ fontSize: 15 }}
						onMouseEnter={() => this.showTooltip(rowId)}
						onMouseLeave={() => this.showTooltip(undefined)}
						id={"schedule-row-" + rowId}
					>
						<i className="fa-solid fa-circle-dollar" style={{ color: overtimeColor, marginLeft: 2 }}></i>

						<ToolTip
							active={rowId === this.state.toolTip}
							position="top"
							arrow="left"
							parent={"#schedule-row-" + rowId}
							key={"#schedule-row-" + rowId}
							group={"#schedule-row-" + rowId}
						>
							<div style={{ display: "grid" }}>
								<div style={{ gridRow: "auto", gridColumn: 1, paddingRight: 10 }}><b>Overtime:</b></div><div style={{ gridRow: "auto", gridColumn: 2 }}>{overtimeNote}</div>
								<div style={{ gridRow: "auto", gridColumn: 1, paddingRight: 10 }}><b>Agency:</b></div><div style={{ gridRow: "auto", gridColumn: 2 }}>{row.AgencyUser ? "true" : "false"}</div>
								<div style={{ gridRow: "auto", gridColumn: 1, paddingRight: 10 }}><b>Pay:</b></div><div style={{ gridRow: "auto", gridColumn: 2 }}>{formatter.format(row.BudgetSummary.Pay)}</div>
								<div style={{ gridRow: "auto", gridColumn: 1, paddingRight: 10 }}><b>Bill:</b></div><div style={{ gridRow: "auto", gridColumn: 2 }}>{formatter.format(row.BudgetSummary.Bill)}</div>
								<div style={{ gridRow: "auto", gridColumn: 1, paddingRight: 10 }}><b>Burden:</b></div><div style={{ gridRow: "auto", gridColumn: 2 }}>{formatter.format(row.BudgetSummary.Burden)}</div>
								<div style={{ gridRow: "auto", gridColumn: 1, paddingRight: 10 }}><b>Net:</b></div><div style={{ gridRow: "auto", gridColumn: 2 }}>{formatter.format(row.BudgetSummary.Net)}</div>
								<div style={{ gridRow: "auto", gridColumn: 1, paddingRight: 10, color: redMarginColor }}><b>Margin:</b></div><div style={{ gridRow: "auto", gridColumn: 2, color: redMarginColor }}>{row.BudgetSummary.Margin}%</div>
							</div>
						</ToolTip>
					</span> : undefined

				const maxWidth = permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.EditSchedule) ? row.AssignedUserProfileImageS3Url ? 165 : 195 : row.AssignedUserProfileImageS3Url ? 190 : 220
				const shiftFilled = row.AssignedUserId
				const poolNumber = (!shiftFilled && row && row.WorkPoolEmployees && row.WorkPoolEmployees.length > 0) ? <span>{row.WorkPoolEmployees.length}</span> : undefined


				const chip =
					<Chip
						data-intercom-target={"Schedule-WeeklySchedule-Chip-OpnAssignEmployeeDialog"}
						style={{ cursor: "pointer", height: 35, minWidth: 75, width: "auto" }}
						onClick={() => !this.props.readonly &&
							permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.EditSchedule) &&
							!row.ShiftTemplates.find(st => st.Used) &&
							this.props.handleAssignEmployee &&
							this.props.handleAssignEmployee(row)
						}
						labelStyle={{ marginLeft: "auto", marginRight: "auto", paddingTop: 2 }}
					>
						{row.AssignedUserProfileImageS3Url &&
							<Avatar style={{ width: 35, height: 35 }}>
								<ImageLoader
									url={row.AssignedUserProfileImageS3Url}
									fixedHeight={60}
									avatar
									src={"/users/profileimage/" + row.AssignedUserProfileImageS3Url}
								/>
							</Avatar>
						}
						{row.AssignedUserId ?
							<div
								style={{ display: "grid", gridTemplateColumns: "auto min-content", maxWidth: maxWidth }}
								title={row.AssignedUserName}
							>
								<div
									className="TextOverflow"
									title={row.AssignedUserName}
									style={{ gridColum: 1, textAlign: "left", paddingRight: 20, fontSize: row.AssignedUserExternalId ? 12 : 14, lineHeight: row.AssignedUserExternalId && "16px" }}
								>
									{row.AssignedUserName}
									<br />
									{row.AssignedUserExternalId &&
										<span style={{ color: "rgb(158, 158, 158)", fontSize: 10 }}>Emp #: {row.AssignedUserExternalId}</span>
									}
								</div>
								<div style={{ gridColumn: 2, textAlign: "right" }}>
									{userType}{budget}
								</div>
							</div> :
							<div
								style={{ display: "grid", gridTemplateColumns: "auto min-content" }}
							>
								<div style={{ gridColum: 1, textAlign: "left", paddingRight: 20 }}>
									<i className="fa fa-user" style={{ fontSize: 18 }} />
								</div>
								<div style={{ gridColumn: 2, textAlign: "right" }}>
									{budget}
								</div>
							</div>
						}
					</Chip>

				return (
					<div style={{ whiteSpace: "nowrap" }}>
						{poolNumber ?
							<Badge badgeContent={poolNumber}
								style={{ cursor: "pointer", height: 35, width: maxWidth - 5, padding: 0 }}
								badgeStyle={{ backgroundColor: "red", color: "white", top: -5, right: -10 }}
							>
								{chip}
							</Badge> :
							chip
						}
					</div>
				)
			},
			ColStyle: { textAlign: "left", cursor: "default", paddingLeft: 0, paddingRight: 0 } as React.CSSProperties
		}]

		if (!this.props.readonly && permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.EditSchedule)) {
			leftSideColumns.push({
				HeaderLabel: "",
				HeaderStyle: { paddingLeft: 10, paddingRight: 5, width: 15 } as React.CSSProperties,
				Col: (row: ISchedulePatternTemplate) => row.AssignedUserId && !row.ShiftTemplates.find(st => st.Used) &&
					<i
						className="fa fa-remove"
						style={{ fontSize: 18, marginTop: 3, cursor: "pointer" }}
						onClick={() => this.props.handleUnAssignEmployee(row)}
					/>,
				ColStyle: { paddingLeft: 10, paddingRight: 5, width: 15, position: "relative" } as React.CSSProperties
			})
			!AppStateStore.hideSchedulePatternTemplate &&
				leftSideColumns.push({
					HeaderLabel: "",
					HeaderStyle: { paddingLeft: 0, paddingRight: 5, width: 25 },
					Col: (row: ISchedulePatternTemplate) =>
						<AddIcon
							style={{ position: "absolute", top: 13, right: 5, cursor: "pointer" }}
							onClick={(e) => {
								e.stopPropagation()
								this.props.handleAddShiftTemplate(row)
							}}
						/>,
					ColStyle: { paddingLeft: 0, paddingRight: 5, width: 25, position: "relative" }
				})
		}
		return (
			<div style={{ marginTop: 25, marginBottom: 15 }}>
				<TableActionBar
					rowSelectionCount={this.state.selectedPatternTemplates.length}
					singleSelectedMessage={strings.Shift_Selected}
					multipleSelectedMessage={strings.x_Shifts_Selected}
					title={strings.Shifts}
					onSearch={searchText => this.setState({ searchText })}
					searchText={this.state.searchText}
					onDeleteClick={() => this.setState({
						confirmDialogContent: strings.Are_you_sure_you_want_to_delete_the_selected_shift,
						confirmDialogPayload: this.state.selectedPatternTemplates
					})}
					readonly={!permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.DeleteSchedule)}
					onCloseSearchClick={() => this.setState({ searchText: "", selectedPatternTemplates: [] })}
					onCopyClick={permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.EditAccountSchedule) ?
						() => this.props.handleOpenCloneDialog(this.state.selectedPatternTemplates) :
						null
					}
				/>
				<div style={{ textAlign: "center" }}>
					{this.props.delaysForDay && this.props.delaysForDay.map((delay, index) => {
						const delayActionDateTimeStr = moment(timeHelper.keepConvertUTCToLocal(delay.ActionDateTimeLocal)).format("dddd, MM/DD/YYYY @ hh:mma")
						return (
							<div key={index}>
								<div>
									{delay.DelayDayLength === 1 ?
										strings.formatString(strings.On_x_x_added_a_1_day_schedule_delay, delayActionDateTimeStr, delay.ActionUserName) as string :
										strings.formatString(strings.On_x_x_added_X_days_schedule_delay, delayActionDateTimeStr, delay.ActionUserName, delay.DelayDayLength.toString()) as string}
								</div>
								<div>{`${strings.Note}: ${delay.Note}`}</div>
							</div>
						)
					})}
				</div>
				{patternTemplates.length === 0 ?
					<Table>
						<TableBody displayRowCheckbox={false}>
							<TableRow>
								<TableRowColumn>
									<h2 style={{ textAlign: "center", marginTop: 25 }}>
										{strings.No_shift_found}
									</h2>
								</TableRowColumn>
							</TableRow>
						</TableBody>
					</Table> :
					<div style={{ marginTop: 10 }}>
						<TimelineTable
							items={patternTemplates}
							timelineData={timelineData}
							timelineItemRenderElement={this.getIimelineItemRenderElement}
							leftSideColumns={leftSideColumns}
							multiSelectable={!this.props.readonly && permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.EditSchedule)}
							selectable={!this.props.readonly && permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.EditSchedule)}
							readonly={this.props.readonly || !permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.EditSchedule)}
							allowDragDrop={this.props.allowDragDrop}
							timelineTableWidth={this.state.width}
							leftSideWidth={300}
							handleSelect={selectedPatternTemplates => this.setState({ selectedPatternTemplates })}
							handleUpdateTimelineData={(timelineItem, rowNumber, orderNumber) =>
								this.props.handleUpdateTimelineData(timelineItem, patternTemplates[rowNumber].ShiftTemplates[orderNumber])
							}
							checkValidateNewTimeline={(timelineItem, rowNumber, orderNumber) =>
								this.props.checkValidateNewTimeline(timelineItem, patternTemplates[rowNumber].ShiftTemplates[orderNumber], patternTemplates[rowNumber])
							}
							handleDeleteTimelineItem={(rowNumber, orderNumber) =>
								this.props.handleDeleteTimelineItem(patternTemplates[rowNumber].ShiftTemplates[orderNumber])
							}
							handleUpdateTimelineItem={this.props.handleUpdateTimelineItem}
							handleDrag={this.props.handleDragPatternTemplate}
							handleDrop={this.props.handleDropPatternTemplate}
							allowQuickEditTime={this.props.allowQuickEditTime}
							excludeNonProductive={this.props.excludeNonProductive}
							scheduleJob={this.props.scheduleJob}
							scheduleClient={this.props.scheduleClient}
						/>
					</div>
				}
				{this.state.confirmDialogContent &&
					<ConfirmDialog
						open
						confirmContent={this.state.confirmDialogContent}
						payload={this.state.confirmDialogPayload}
						close={() => this.setState({ confirmDialogContent: "", confirmDialogPayload: null })}
						confirm={(action, payload) => {
							this.setState({ confirmDialogContent: "", confirmDialogPayload: null, selectedPatternTemplates: [] })
							this.props.handleDeletePatternTemplates(payload)
						}}
					/>
				}
			</div>
		)
	}
}

interface ITimelineItemProps {
	timelineItem: IScheduleDailyTimelineData
	rowNumber: number
	orderNumber: number

	timelineItemData: IScheduleShift
	patternTemplates: ISchedulePatternTemplate[]
	handleShowTimecardPopup(employeeId: string, referenceDate: IDate): void
}
interface ITimelineItemState {
	punchInTimeLocalStr: string
	punchOutTimeLocalStr: string
}
class TimelineItem extends React.Component<ITimelineItemProps, ITimelineItemState> {
	constructor(props: ITimelineItemProps) {
		super(props)
		this.state = {
			punchInTimeLocalStr: null,
			punchOutTimeLocalStr: null
		}
	}

	async componentDidMount() {
		let punchInTimeLocalStr = null
		let punchOutTimeLocalStr = null
		if (this.props.timelineItemData.PunchInTime) {
			const punchInTimeLocalTime = await timeHelper.getDateTime(this.props.timelineItemData.HierarchyId, this.props.timelineItemData.JobId, this.props.timelineItemData.PunchInTime)
			punchInTimeLocalStr = punchInTimeLocalTime.format("h:mma")
		}
		if (this.props.timelineItemData.PunchOutTime) {
			const punchOutTimeLocalTime = await timeHelper.getDateTime(this.props.timelineItemData.HierarchyId, this.props.timelineItemData.JobId, this.props.timelineItemData.PunchOutTime)
			punchOutTimeLocalStr = punchOutTimeLocalTime.format("h:mma")
		}
		this.setState({ punchInTimeLocalStr, punchOutTimeLocalStr })
	}

	render() {
		const { timelineItemData } = this.props
		const jobName = timelineItemData.JobName
		const shiftTime = `${timeHelper.getTimeStringSimpleFormatFromSimpleTime(this.props.timelineItem.StartTime)}-${timeHelper.getTimeStringSimpleFormatFromSimpleTime(this.props.timelineItem.EndTime)}`
		const punchInTime = timelineItemData.PunchInTime && `${strings.In}: ${this.state.punchInTimeLocalStr}`
		const punchOutTime = timelineItemData.PunchOutTime && `${strings.Out}: ${this.state.punchOutTimeLocalStr}`
		const shiftCost = timelineItemData.ScheduleCost ? "$" + timelineItemData.ScheduleCost.TotalCost : null

		return (
			<div style={{ backgroundColor: this.props.timelineItem.Color, height: 46, textAlign: "center", display: "flex" }}>
				<div style={{ flex: 0.2 }} />
				<div style={{ display: "flex", flexDirection: "column", justifyContent: "center", color: "white", flex: 1, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
					{jobName &&
						<div title={jobName} className="TextOverflow" style={{ position: "relative" }}>
							{jobName}
						</div>
					}
					<div title={shiftTime} className="TextOverflow" style={{ position: "relative" }}>
						{shiftTime}
					</div>
					{timelineItemData.PunchInTime &&
						<div
							style={{ marginTop: -5, fontSize: 10, position: "relative" }}
							title={punchOutTime ? `${punchInTime} - ${punchOutTime} ${shiftCost}` : punchInTime}
							className="TextOverflow"
						>
							<ImageTimer
								style={{ color: "white", width: 10, height: 10, position: "absolute", top: 4 }}
								onClick={() => permissionHelper.hasPermission(AuthenticationStore.Permissions.Timecards.ViewTimecards) &&
									this.props.handleShowTimecardPopup(this.props.patternTemplates[this.props.rowNumber].AssignedUserId, timelineItemData.StartDateTime)
								}
							/>
							<span style={{ marginLeft: 13 }}>{punchInTime}</span>
							{timelineItemData.PunchOutTime &&
								<span style={{ marginLeft: 3 }}>{punchOutTime}</span>
							}
						</div>
					}
				</div>
				<div style={{ flex: 0.1 }} />
				<div style={{ flex: 1, height: 30, marginTop: 8, fontSize: 15, borderRadius: 15, backgroundColor: utils.getMaterial900ColorFrom500Color(this.props.timelineItem.Color), color: "rgba(254, 254, 254, 0.5)" }} className="TextOverflow">
					<div style={{ marginTop: 5, paddingLeft: 5, paddingRight: 5 }} title={timelineItemData.Name} className="TextOverflow">
						{timelineItemData.Name}
					</div>
				</div>
				<div style={{ flex: 0.2 }} />
			</div>
		)
	}
}